<template>
  <b-card
    class="p-3 h-100 matched-job-list-item"
    :class="{
      'border-0': noBorder,
      'border-top-0': layout === 'minimal',
      'border-right-0': layout === 'minimal',
      'border-left-0': layout === 'minimal',
    }"
    body-class="p-0 pb-3"
    footer-class="bg-primary-a1 border-0 rounded px-3"
  >

    <b-row v-if="isHighlighted" class="pb-3 mb-3 border-bottom">
      <b-col cols="12" class="block-title">Selected Role</b-col>
      <b-button
        size="sm"
        class="edit-button"
        variant="link"
        @click="$emit('closeHighlightedRole')"
      >
        close
      </b-button>
    </b-row>

    <!-- title and custom fields -->
    <div class="mt-0">
      <b-row>
        <!-- b-col :cols="matchingTooltips.skills && matchingTooltips.interest ? 6 : (matchingTooltips.skills || matchingTooltips.interest ? 8 : 12)" -->
        <b-col cols="12">
          <h4 class="pb-0 mb-1" :style="{ 'font-size': layout === 'minimal' ? '0.9rem' : '1.1rem' }">
            <span
              v-if="job.status !== 'ACTIVE' && isRecruiter"
              class="mr-2"
            >{{job.status}}</span>
            <span
              v-if="isMatch"
              class="development-tag"
              :style="{ backgroundColor: '#FFC400', fontSize: '14px', position: 'relative', bottom: '2px' }"
              v-b-tooltip.hover title="We think this position is a good match for you."
            >Match</span>
            <b>{{ job.title }}</b>
            <span
              v-if="job.isDevelopment && layout !== 'minimal'"
              class="development-tag"
              :style="{ backgroundColor: developmentMatchBG, fontSize: '14px', position: 'relative', bottom: '2px' }"
              v-b-tooltip.hover title="We think this role is a good match for you."
            ><font-awesome-icon style="font-size: 13px" icon="signal"/> Development</span>
          </h4>
        </b-col>
        <!--b-col
          v-if="matchingTooltips.skills || matchingTooltips.interest"
          :cols="matchingTooltips.skills && matchingTooltips.interest ? 6 : 4"
        >
          <b-badge
            v-if="$root.isInterestBasedMatching && matchingTooltips.interest"
            class="float-right px-2 py-2 ml-2"
            variant="warning"
            pill
            v-b-tooltip.hover :title="matchingTooltips.interest"
          >
            Interest Match
          </b-badge>
          <b-badge
            v-if="$root.isInterestBasedMatching && matchingTooltips.skills"
            class="float-right px-2 py-2"
            variant="warning"
            pill
            v-b-tooltip.hover :title="matchingTooltips.skills"
          >
            Skill Match
          </b-badge>

          <b-badge
            v-if="!$root.isInterestBasedMatching && matchingScore > 1"
            class="float-right px-2 py-2"
            variant="warning"
            pill
            v-b-tooltip.hover :title="matchingTooltips.skills"
          >
            Match
          </b-badge>
        </b-col -->
      </b-row>
      <p v-if="isProjectDisplay && job.project &&  !['select-modal'].includes(layout)">
        <b>Project: {{ job.project.title }}</b>
      </p>
      <p
        v-if="(job.location || (job.customFieldsHash && (job.customFieldsHash.contract || job.customFieldsHash.seniority || job.customFieldsHash.businessArea || job.customFieldsHash.brands))) && layout !== 'minimal'"
        class="my-2"
        style="font-size: 0.8rem !important"
      >
        <span
          v-if="interest.location.value"
          :class="{ 'mr-2': true, 'development-tag': interest.location.isMatch && isMatch }"
          :style="{ backgroundColor: interest.location.isMatch && isMatch ? developmentMatchBG : null }"
          v-b-tooltip.hover :title="interest.location.tooltip ? interest.location.tooltip : ''"
        >
          <font-awesome-icon class="text-muted" icon="map-marker"/> {{ interest.location.value.name }}<template v-if="interest.location.value.countryCode">, {{ interest.location.value.countryCode }}</template>
        </span>
        <span v-if="interest.contract.value" class="mr-2">
          <font-awesome-icon class="text-muted" icon="clock"/> {{ interest.contract.value }}
        </span>
        <span
          v-if="interest.seniority.value"
          :class="{ 'mr-2': true, 'development-tag': interest.seniority.isMatch && isMatch }"
          :style="{ backgroundColor: interest.seniority.isMatch && isMatch ? developmentMatchBG : null }"
          v-b-tooltip.hover :title="interest.seniority.tooltip ? interest.seniority.tooltip : ''"
        >
          <font-awesome-icon class="text-muted" icon="user-tie"/> {{ interest.seniority.value }}
        </span>
        <span
          v-if="interest.businessArea.value"
          :class="{ 'mr-2': true, 'development-tag': interest.businessArea.isMatch && isMatch }"
          :style="{ backgroundColor: interest.businessArea.isMatch && isMatch ? developmentMatchBG : null }"
          v-b-tooltip.hover :title="interest.businessArea.tooltip ? interest.businessArea.tooltip : ''"
        >
          <font-awesome-icon class="text-muted" icon="briefcase"/> {{ interest.businessArea.value }}
        </span>
        <span
          v-if="job.customFieldsHash.salaryRange"
          :class="{ 'mr-2': true, 'development-tag': interest.seniority.isMatch && isMatch }"
          :style="{ backgroundColor: interest.seniority.isMatch && isMatch ? developmentMatchBG : null }"
          v-b-tooltip.hover :title="interest.seniority.tooltip ? interest.seniority.tooltip : ''"
        >
          <font-awesome-icon class="text-muted" icon="user-tie"/> {{ job.customFieldsHash.salaryRange }}
        </span>
        <span
          v-if="job.customFieldsHash.brands"
          :class="{ 'mr-2': true }"
        >
          <font-awesome-icon class="text-muted" icon="industry"/> {{ job.customFieldsHash.brands }}
        </span>
      </p>
    </div>

    <!-- description -->
    <!-- p v-if="!['tiny', 'minimal'].includes(layout)" class="text-muted">{{ truncute(job.description, 164) }}</p -->

    <!-- skills -->
    <div v-if="skills && layout !== 'select-modal'" :class="{ 'my-3': ['tiny', 'minimal'].includes(layout) }">
      <span
        class="skill-tag mr-1 mt-1"
        v-for="skill in skills"
        :style="{ backgroundColor: skill.background }"
        :key="skill.name"
        v-b-tooltip.hover :title="skill.tooltip ? skill.tooltip : ''"
      >{{ skill.name }}</span>
    </div>

    <!-- job button in minimal mode -->
    <div v-if="(job.status === 'ACTIVE' || isRecruiter) && !isProjectDisplay && layout === 'minimal'">
      <b-button class="float-right px-4" :to="{ name: 'InternalJobShow', params: { jobID: job.id } }" variant="primary" size="sm">
        {{ job.project ? 'View Role' : 'View Job' }}
      </b-button>
    </div>

    <div
      v-else
      slot="footer"
      class="border-0 p-0 d-flex justify-content-between align-items-center"
    >
      <!-- dates -->
      <div v-if="layout !== 'minimal'">
        <span v-if="job.customFieldsHash && job.customFieldsHash.startDate">
          <span class="text-muted" style="font-size: 13px">Start <b>{{ formatDate(parseInt(job.customFieldsHash.startDate), 'DD.MM.YYYY') }}</b></span>
        </span>
        <br v-if="job.customFieldsHash && job.customFieldsHash.endDate" />
        <span v-if="job.customFieldsHash && job.customFieldsHash.endDate">
          <span class="text-muted" style="font-size: 13px">Est. End <b>{{ formatDate(parseInt(job.customFieldsHash.endDate), 'DD.MM.YYYY') }}</b></span>
        </span>
      </div>

      <div v-if="(job.status === 'ACTIVE' || isRecruiter) && !isProjectDisplay && !['tiny', 'minimal', 'select-modal'].includes(layout)">
        <!-- b-button v-if="!isRecruiter" class="float-right ml-2" size="sm" variant="primary" :to="{ name: 'InternalJobShow', params: { jobID: job.id } }">
          Apply
        </b-button -->
        <b-button class="float-right" size="sm" variant="primary" :to="{ name: 'InternalJobShow', params: { jobID: job.id } }">
          {{ job.project ? 'View Role' : 'View Job' }}
        </b-button>
      </div>

      <!-- job button in tiny mode -->
      <div v-if="(job.status === 'ACTIVE' || isRecruiter) && !isProjectDisplay && layout === 'tiny'">
        <!-- b-button v-if="!isRecruiter" class="float-right ml-2 px-4" variant="primary" :to="{ name: 'InternalJobShow', params: { jobID: job.id } }">
          Apply Now
        </b-button -->
        <b-button class="float-right px-4" variant="primary" :to="{ name: 'InternalJobShow', params: { jobID: job.id } }">
          {{ job.project ? 'View Role' : 'View Job' }}
        </b-button>
      </div>

      <!-- job button in import mode -->
      <!-- div v-if="displayDetachButton">
        <b-button
          size="sm"
          class="float-right px-4 mr-3"
          variant="outline-danger"
          @click="$emit('detachJob', job.id)"
        >
          Detach Role
        </b-button>
      </div -->

      <!-- job button in import mode -->
      <div v-if="(job.status === 'ACTIVE' || isRecruiter) && layout === 'select-modal'">
        <b-button
          class="float-right px-4"
          variant="primary"
          :disabled="disableImportButton"
          @click="onImportButtonClicked(job.id)"
        >
          Attach Job
        </b-button>
      </div>

      <!-- project button -->
      <b-button
        class="float-right px-4"
        variant="primary"
        v-if="(job.status === 'ACTIVE' || isRecruiter) && isProjectDisplay && job.project && !['tiny', 'minimal'].includes(layout)"
        :to="{ name: 'ProjectShow', params: { projectID: job.project.id }, query: { jobID: job.id } }"
      >
        View Role
      </b-button>

      <!-- project button in tiny mode -->
      <div v-if="(job.status === 'ACTIVE' || isRecruiter) && isProjectDisplay && job.project && layout === 'tiny'">
        <b-button
          class="float-right px-4"
          variant="primary"
          :to="{ name: 'ProjectShow', params: { projectID: job.project.id }, query: { jobID: job.id } }"
        >
          View Role
        </b-button>
      </div>

      <!-- project button in minimal mode -->
      <div v-if="(job.status === 'ACTIVE' || isRecruiter) && isProjectDisplay && job.project && layout === 'minimal'">
        <b-link
          class="float-right px-4"
          :to="{ name: 'ProjectShow', params: { projectID: job.project.id }, query: { jobID: job.id } }"
        >
          View Role
        </b-link>
      </div>
    </div>
  </b-card>

</template>

<script>
import formatDate from 'date-fns/format';
import tinycolor from 'tinycolor2';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    job: {
      type: Object,
    },
    matchedJob: {
      type: Object,
      default: () => null,
    },
    isProjectDisplay: {
      type: Boolean,
      default: false,
    },
    displayDetachButton: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: () => 'block',
      validate: layout => [ 'minimal', 'tiny', 'block', 'page', 'select-modal' ].includes(layout),
    },
    isHighlighted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disableImportButton: false,
    };
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isLoggedIn', 'isRecruiter' ]),
    hideJobExcerpts() {
      const { sitePreferences: { hideJobExcerpts = false } = {} } = this.company;
      return hideJobExcerpts === true;
    },
    toCandidates() {
      return {
        ...this.toJob,
        hash: '#candidates',
      };
    },
    skills() {
      const { job, matchBG, developmentMatchBG, isMatch } = this;
      if (Array.isArray(job.skills) && job.skills.length) {
        const hasSkillMatches = job.imMatchingDetails &&
          Array.isArray(job.imMatchingDetails.skillsData) &&
          job.imMatchingDetails.skillsData.length;
        let skills = [
          ...(Array.isArray(job.skills) ? job.skills : []),
          ...(Array.isArray(job.nonRequiredSkills) ? job.nonRequiredSkills : [])
        ].map(skill => {
          const matchDetails = hasSkillMatches ? job.imMatchingDetails.skillsData.find(el => skill === el.value) : null;
          const developmentTypes = [ 'SKILL_DEVELOPMENT', 'NON_REQUIRED_SKILL', 'NON_REQUIRED_SKILL_DEVELOPMENT' ];
          return {
            isMatch: !!matchDetails && isMatch,
            background: matchDetails
              ? (matchDetails.type === 'SKILL' && isMatch
                ? matchBG : (developmentTypes.includes(matchDetails.type) ? developmentMatchBG : '#eee')
              ) : '#eee',
            name: skill,
            score: matchDetails ? matchDetails.score : 0,
            tooltip: this.getTooltip(matchDetails),
          };
        }).sort((a, b) => b.score - a.score);
        skills = skills.length > 5 ? [
          ...skills.slice(0, 4),
          { isMatch: false, background: '#eee', score: 0, tooltip: null, name: `+${skills.length - 5}` }
        ] : skills;
        return skills;
      }
      return null;
    },
    interest() {
      const { job } = this;
      const hasInterestMatches = job.imMatchingDetails &&
          Array.isArray(job.imMatchingDetails.interestData) &&
          job.imMatchingDetails.interestData.length;
      const matches = hasInterestMatches ? job.imMatchingDetails.interestData : [];
      const { location, customFieldsHash } = job;
      const { contract, seniority, businessArea } = customFieldsHash || {};
      console.log('JOB: ', job);
      return {
        location: {
          value: location || (customFieldsHash.location ? { name: customFieldsHash.location } : null),
          isMatch: !!matches.find(({ type }) => type === 'JOB_LOCATION'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_LOCATION')),
        },
        seniority: {
          value: seniority,
          isMatch: !!matches.find(({ type }) => type === 'JOB_SENIORITY'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_SENIORITY')),
        },
        businessArea: {
          value: businessArea,
          isMatch: !!matches.find(({ type }) => type === 'JOB_BUSINESS_AREA'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_BUSINESS_AREA')),
        },
        contract: {
          value: contract,
          isMatch: !!matches.find(({ type }) => type === 'JOB_CONTRACT'),
          tooltip: this.getTooltip(matches.find(({ type }) => type === 'JOB_CONTRACT')),
        },
      };
    },
    matchingScore() {
      const { job } = this;
      if (job.imMatchingDetails) {
        return (job.imMatchingDetails.interestScore || 0) + (job.imMatchingDetails.skillScore || 0);
      }
      return 0;
    },
    isMatch() {
      const { imMatchingDetails } = this.job;
      if (!imMatchingDetails) return false;
      const { score } = imMatchingDetails;
      return score >= 3;
    },
    matchingTooltips() {
      const { job } = this;
      const matchingTooltips = {
        skills: null,
        interest: null,
      };
      const hasInterestMatches = job.imMatchingDetails &&
        Array.isArray(job.imMatchingDetails.interestData) &&
        job.imMatchingDetails.interestData.length;
      if (hasInterestMatches) {
        const interestCount = job.imMatchingDetails.interestData.length;
        const interestPlural = interestCount > 1;
        matchingTooltips.interest = `${interestCount} of your interests match${interestPlural ? '' : 'es'} with this opening.`;
      }
      const hasSkillsMatches = job.imMatchingDetails &&
        Array.isArray(job.imMatchingDetails.skillsData) &&
        job.imMatchingDetails.skillsData.length;
      if (hasSkillsMatches) {
        const skillsCount = job.imMatchingDetails.skillsData.length;
        const skillsPlural = skillsCount > 1;
        matchingTooltips.skills = `${skillsCount} of your skills match${skillsPlural ? '' : 'es'} with this opening.`;
        const synonyms = job.imMatchingDetails.skillsData
          .filter(({ type }) => [ 'SYNONYM_DEVELOPMENT', 'SYNONYM' ].includes(type))
          .map(({ value }) => value);
        if (synonyms.length) {
          matchingTooltips.skills = `${matchingTooltips.skills} Your following skill${synonyms.length > 1 ? 's' : ''} may also make you a good fit: ${synonyms.join(', ')}`;
        }
      }
      return matchingTooltips;
    },
    matchBG() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(34).toString() : '#eee';
    },
    developmentMatchBG() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(42).toString() : '#eee';
    },
  },
  methods: {
    getTooltip(matchDetails) {
      if (matchDetails && matchDetails.type) {
        if (matchDetails.type === 'SKILL') {
          return 'Direct match with one of your skills.';
        } else if (matchDetails.type === 'SKILL_DEVELOPMENT') {
          return 'Direct match with one of your development skills.';
        } else if (matchDetails.type === 'JOB_TITLE') {
          return 'Matches with a job title you are interested in.';
        } else if (matchDetails.type === 'JOB_BUSINESS_AREA') {
          return 'Matches with a business area title you are interested in.';
        } else if (matchDetails.type === 'JOB_SENIORITY') {
          return 'Matches with a job seniority level you are interested in.';
        } else if (matchDetails.type === 'JOB_LOCATION') {
          return 'Matches with a location you are interested in.';
        } else if (matchDetails.type === 'NON_REQUIRED_SKILL') {
          return 'Optional skill matches with one of your current skills';
        } else if (matchDetails.type === 'NON_REQUIRED_SKILL_DEVELOPMENT') {
          return 'Optional skill matches with one of your skills you want to develop';
        }
      }
      return null;
    },
    truncute(str, limit) {
      return str.length > limit ? `${str.substr(0, limit)}...` : str;
    },
    formatDate,
    onImportButtonClicked(jobID) {
      this.$emit('importJob', { jobID });
      this.disableImportButton = true;
    },
  }
};
</script>

<style lang="scss">
.matched-job-list-item {
  .skill-tag {
    display: inline-block;
    font-size: 13px;
    padding: 3px 6px;
    border-radius: 2px;
  }
  .development-tag {
    position: relative;
    display: inline-block;
    padding: 3px 10px;
    border-radius: 2px;
  }
  .edit-button {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10;
  }
  .block-title {
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/UserMatchListItem.vue